export default "__VITE_ASSET__d89b4513__"